import { ReactNode } from 'react'

import { Box, Button, type Icon } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/PopoverMenu'

import * as styles from './index.vanilla.css'

export interface Action {
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  label: string
  onClick?: () => void
  to?: string
  disabled?: boolean
}

export interface Option {
  title: string
  description?: string
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
  onClick?: () => void
  to?: string
  href?: React.ComponentProps<typeof Popover.HrefOption>['href']
  download?: React.ComponentProps<typeof Popover.HrefOption>['download']
  target?: React.ComponentProps<typeof Popover.HrefOption>['target']
  danger?: boolean
}

interface Props {
  options?: Option[]
  optionsButton?: ReactNode
  action?: Action
}

const OptionType = ({ item }: { item: Option }) => {
  if (item.to) {
    return (
      <Popover.RouterOption
        title={item.title}
        description={item.description}
        to={{ pathname: item.to }}
        onClick={item.onClick}
        danger={item.danger}
        icon={item.icon}
      />
    )
  }

  if (item.href) {
    return (
      <Popover.HrefOption
        title={item.title}
        description={item.description}
        href={item.href}
        target={item.target || '_blank'}
        danger={item.danger}
        download={item.download}
      />
    )
  }

  return (
    <Popover.TouchableOption
      title={item.title}
      description={item.description}
      onClick={item.onClick}
      danger={item.danger}
    />
  )
}

const Options = ({ options }: { options: Option[] }) => {
  const optionsButtonContent = () => {
    return <Button.Decorative type="secondary" iconName="ellipsis" />
  }

  return (
    <Popover type="list">
      <Popover.Trigger>{optionsButtonContent()}</Popover.Trigger>
      <Popover.Content side="bottom" align="center" hideWhenDetached={false}>
        {options.map((item: Option, index: number) => {
          return <OptionType item={item} key={index} />
        })}
      </Popover.Content>
    </Popover>
  )
}

const Actions = ({ options }: Props) => {
  if (!options) return null

  return (
    <Box gap="s8" flexDirection="row" justifyContent="flexEnd" className={styles.right}>
      {options && <Options options={options} />}
    </Box>
  )
}

export default Actions
